export function canManageTenantTeam({ role, isSuperAdmin }) {
  return role === "TENANT_ADMIN" && !isSuperAdmin;
}

export function getTeamRoleLabel(role) {
  if (role === "TENANT_ADMIN") return "Administrator";
  if (role === "SALES_USER") return "Vertrieb";
  if (role === "VIEWER") return "Betrachter";
  return role || "—";
}

export function mapTeamMembersError(status) {
  if (status === 401) return "Bitte melde dich erneut an.";
  if (status === 403) return "Du hast keine Berechtigung, dieses Team zu verwalten.";
  return "Die Mitglieder konnten nicht geladen werden.";
}

export function mapTeamInviteError(status, detail) {
  if (status === 400) return detail || "Die Eingaben konnten nicht verarbeitet werden.";
  if (status === 401) return "Bitte melde dich erneut an.";
  if (status === 403) return "Du hast keine Berechtigung, Nutzer einzuladen.";
  if (status === 409) return "Für diese E-Mail existiert bereits ein Nutzer oder eine offene Einladung.";
  if (status === 422) return "Bitte prüfe deine Eingaben.";
  return "Die Einladung konnte nicht versendet werden.";
}
